import api from "@/services/api";
import { DashboardCompanyStatsResponse } from "@/interfaces/DashboardCompanyStats";

export const dashboardCompanyStatsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDashboardCompanyStats: build.query<DashboardCompanyStatsResponse, void>({
      query: () => ({ url: "/admin/stats/companies" }),
      providesTags: [{ type: "DashboardStats", id: "COMPANIES" }],
    }),
  }),
  overrideExisting: true,
});

export const { useGetDashboardCompanyStatsQuery } = dashboardCompanyStatsApi;
